/**
 * Liberian dollar.
 */
export var LRD = {
  code: 'LRD',
  base: 10,
  exponent: 2
};